<template>
  <div class="hotel-selection-content-desktop-layout">
    <div class="left-column">
      <slot name="leftColumn" />
    </div>
    <div class="middle-column">
      <div class="middle-column-top"><slot name="middleColumnTop" /></div>
      <div class="middle-column-bottom">
        <slot name="middleColumnBottom" />
      </div>
    </div>
    <div class="right-column"><slot name="rightColumn" /></div>
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-content-desktop-layout {
  height: 100%;
  background-color: var(--color-white);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .left-column,
  .middle-column,
  .right-column {
    height: 100%;
    min-width: 0;
  }

  .left-column {
    border-right: 1px solid var(--color-secondary-93);
    width: 370px;
    overflow-y: auto;
  }

  .middle-column {
    background-color: var(--color-quaternary-70);
    flex: 7;
    max-width: 800px;
  }

  .right-column {
    flex: 4;
  }

  .middle-column {
    display: flex;
    flex-direction: column;

    .middle-column-bottom {
      overflow-y: auto;
    }
  }

  @include for-less-or-equal-than-large-max {
    .left-column {
      display: none;
    }

    .middle-column {
      flex: 7;
    }

    .right-column {
      flex: 5;
    }
  }

  @include for-less-or-equal-than-medium-max {
    .middle-column {
      flex: 1;
    }

    .right-column {
      flex: 1;
    }
  }
}
</style>
